import { render, staticRenderFns } from "./ButtonPoints.vue?vue&type=template&id=21cd06f0&"
import script from "./ButtonPoints.vue?vue&type=script&lang=js&"
export * from "./ButtonPoints.vue?vue&type=script&lang=js&"
import style0 from "./ButtonPoints.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports